/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BridgeConfig } from './bridge/bridge.config';
import { BridgeMockService } from './bridge/bridge.mocks.service';
import { BridgeServiceProvider } from './bridge/bridge.service.provider';
import { CrimsonConfig } from './crimson.config';
import { AutoScrollOnExpandDirective } from './directives/auto-scroll-on-expand.directive';
import { CustomShowHideDirective } from './layout/custom-show-hide.directive';
import { LocaleConfig } from './locale-service/locale.config';
import { LoggerConfig } from './logging/logging.service';
import { BytesPipe } from './pipes/byte.pipe';
import { FilenamePipe, FilenameNoExtensionPipe, ExtensionPipe, DirectoryPipe } from './pipes/filename.pipe';
import { HhmmssPipe, SecondsPipe, TimePipe } from './pipes/time.pipe';
import { TrustAsHtmlPipe } from './pipes/trust-ashtml.pipe';
import { WindowConfig } from './window/window.config';

// Standalone items that this NgModule imports and re-exports for backward compatibility
const STANDALONE_PIPES_TO_IMPORT_AND_EXPORT = [
    BytesPipe,
    HhmmssPipe,
    SecondsPipe,
    TimePipe,
    FilenamePipe,
    FilenameNoExtensionPipe,
    ExtensionPipe,
    DirectoryPipe,
    TrustAsHtmlPipe
];

const STANDALONE_DIRECTIVES_TO_IMPORT_AND_EXPORT = [AutoScrollOnExpandDirective, CustomShowHideDirective];

@NgModule({
    imports: [...STANDALONE_PIPES_TO_IMPORT_AND_EXPORT, ...STANDALONE_DIRECTIVES_TO_IMPORT_AND_EXPORT],
    exports: [...STANDALONE_PIPES_TO_IMPORT_AND_EXPORT, ...STANDALONE_DIRECTIVES_TO_IMPORT_AND_EXPORT]
})
export class CrimsonModule {
    public static configure(config: CrimsonConfig): ModuleWithProviders<CrimsonModule> {
        return {
            ngModule: CrimsonModule,
            providers: [
                DatePipe,
                {
                    provide: LoggerConfig,
                    useValue: config.logger
                },
                {
                    provide: BridgeConfig,
                    useValue: config.bridge
                },
                {
                    provide: WindowConfig,
                    useValue: config.window
                },
                {
                    provide: LocaleConfig,
                    useValue: config.locale
                },
                BridgeMockService,
                BridgeServiceProvider
            ]
        };
    }
}
